export function statusRecordingRenderer(param: { value: number }) {
  const { value } = param;
  return `<span class='fa fa-microphone state${value}'/>`;
}
